// extracted by mini-css-extract-plugin
export default {"nav-link":"NavItemComponent_nav-link_pr2QU","submenu-item":"NavItemComponent_submenu-item_PcbKx"};